import { render, staticRenderFns } from "./FieldBox.vue?vue&type=template&id=2ab179a7&scoped=true"
import script from "./FieldBox.vue?vue&type=script&lang=js"
export * from "./FieldBox.vue?vue&type=script&lang=js"
import style0 from "./FieldBox.vue?vue&type=style&index=0&id=2ab179a7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab179a7",
  null
  
)

export default component.exports